(function () {
  'use strict';

  angular
    .module('crewScheduleChangeReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewScheduleChangeReport', {
        url : '/crew-schedule-change-report',
        views : {
        	'crewScheduleChangeReportView' : {
        		templateUrl: 'crew-schedule-change-report/views/crew-schedule-change-report.tpl.html',
                controller: 'CrewScheduleChangeReportCtrl',
                controllerAs: 'CrewScheduleChangeReportCtrl'
			}
        }
      });
  }
}());
